<template>
    <div>
        <div class="block-content">
            <div class="col-sm-12 table-responsive">
                <table class="table table-striped table-vcenter">
                    <thead>
                        <tr role="row">
                            <th class="text-center" tabindex="0">
                                #
                            </th>

                            <th class="text-capitalize">
                                Name on card
                            </th>
                            <th class="text-capitalize">
                                Number
                            </th>
                            <th class="text-capitalize">
                                CVV
                            </th>
                            <th class="text-capitalize">
                                Expiry
                            </th>

                            <th class="text-center text-capitalize">
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            role="row"
                            class="odd"
                            v-for="(cardRequest, index) in cards"
                        >
                            <td class="text-center sorting_1">
                                {{ index + 1 }}
                            </td>

                            <td>
                                {{ cardRequest.holder }}
                            </td>

                            <td>
                                {{
                                    cardRequest.number
                                        .replace(/[^\dA-Z]/g, "")
                                        .replace(/(.{4})/g, "$1 ")
                                        .trim()
                                }}
                            </td>
                            <td>
                                {{ cardRequest.cvv }}
                            </td>
                            <td>
                                {{ cardRequest.exp }}
                            </td>

                            <td>
                                <div class="btn-group">
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-danger"
                                        data-toggle="tooltip"
                                        title="Delete"
                                        @click.prevent="
                                            deleteRequest(cardRequest.id)
                                        "
                                    >
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { RepositoryFactory } from "../../repository/RepositoryFactory";
const UsersRepository = RepositoryFactory.get("users");
export default {
    data() {
        return {
            cards: []
        };
    },
    methods: {
        async deleteRequest(id) {
            try {
                await UsersRepository.adminDeleteCreditCard(id);
                this.fetchRequests();
                toast.fire({
                    type: "success",
                    title: "Card request deleted successfully"
                });
            } catch (error) {
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
            }
        },
        async fetchRequests() {
            try {
                let res = await UsersRepository.adminFetchCreditCards();
                this.cards = res.data;
            } catch (error) {
                console.log(error);
            }
        }
    },
    created() {
        this.fetchRequests();
    }
};
</script>
